export default "__VITE_ASSET__Rdvw3oiM__"